$(document).ready(function(){

    // Configuration: Product handles that should default to one-time purchase
    const ONE_TIME_DEFAULT_PRODUCTS = [
        // Original buy1 products
        'melatonin-buy1',
        'coq10-buy1', 
        'berberine-buy1',
        'mushroom-complex-buy1',
        'probiotics-60-billion-cfu-buy1',
        'ashwagandha-buy1',
        'turmeric-ginger-buy1',
        'ashwagandha-v2',
        'berberine-v2',
        'coq10-v2',
        'melatonin-v2',
        'mushroom-complex-v2',
        'probiotics-v2',
        'turmeric-and-ginger-v2'
    ];

    /**
     * Set default purchase mode based on current product
     */
    function setDefaultPurchaseMode() {
        const currentHandle = window.location.pathname.split('/').pop() || 
                             window.product?.handle || 
                             document.querySelector('[data-product-handle]')?.getAttribute('data-product-handle');
        
        if (currentHandle && ONE_TIME_DEFAULT_PRODUCTS.includes(currentHandle)) {
            // Switch to one-time purchase as default
            $('.md_mode_select_tab').removeClass('active');
            $('.md_mode_select_tab[data="onetime"]').addClass('active');
            
            // Update form visibility
            $('.md_purchase_form_sub').hide();
            $('.md_purchase_form_ot').show();
            $('.md_prices_otp').removeClass('hided');
            $('.md_prices_sub').addClass('hided');
            $('.md_quantity_price[data="sub"]').hide();
            $('.md_quantity_price[data="otp"]').css('display', 'flex');
            
            console.log(`Default mode set to One-Time Purchase for: ${currentHandle}`);
        }
    }

    // Apply default mode setting
    setDefaultPurchaseMode();

    // Rest of your existing code remains unchanged...
    
    $('.md_autodelivery_freq_select').click(function(){
        $(this).closest('.md_freq_select_outt').find('.md_autodelivery_freq_select_inn').toggle();
    });

    $('.md_autodelivery_freq_select_inn div.md_autodelivery_plan').click(function(){
        $('.md_autodelivery_freq_select_inn').hide();

        var value = $(this).html();
        var valueMob = value.substring(0, 29); 
        if (value.length > 29) {
            valueMob += "..."; 
        }
        $('.md_autodelivery_freq_select div.Desktop_only').html(value);
        $('.md_autodelivery_freq_select div.Mobile_only').html(valueMob);

        $('.md_autodelivery_plan').removeClass('active');
        $(this).addClass('active');

        var sellingId = $(this).attr('data');
        $('.md_quantity_box.active').trigger('click');
    });

    $('.md_quantity_box').click(function(){
        $('.md_quantity_box').removeClass('active');
        $(this).addClass('active');

        var currentQty = $(this).attr('data');
        $('.md_price_qty').addClass('hided');
        $('.md_price_qty[data="'+currentQty+'"]').removeClass('hided');

        var currentId = $(this).attr('data-id');
        $('.otpPriceLabel__js').hide();
        $('.otpPriceLabel__js[data-id="'+currentId+'"]').show();

        $('.md_ot_save').hide();
        $('.md_ot_save[data-id="'+currentId+'"]').show();

        $('.md_frequencies_boxy').hide();
        $('.md_frequencies_boxy[data-id="' + currentId + '"]').show();

        $('.md_purchase_form_ot .md_autodelivery_freq_label').hide();
        $('.md_purchase_form_ot .md_autodelivery_freq_label[data-id="' + currentId + '"]').show();
    });

    $('.md_mode_select_tab').click(function(){
        $('.md_mode_select_tab').removeClass('active');
        $(this).addClass('active');
        var data = $(this).attr('data');

        if (data == 'autodelivery'){
            $('.md_purchase_form_sub').show();
            $('.md_purchase_form_ot').hide();
            $('.md_prices_otp').addClass('hided');
            $('.md_prices_sub').removeClass('hided');
            $('.md_quantity_price[data="otp"]').hide();
            $('.md_quantity_price[data="sub"]').css('display', 'flex');
        }
        else if ( data == 'onetime'){
            $('.md_purchase_form_sub').hide();
            $('.md_purchase_form_ot').show();
            $('.md_prices_otp').removeClass('hided');
            $('.md_prices_sub').addClass('hided');
            $('.md_quantity_price[data="sub"]').hide();
            $('.md_quantity_price[data="otp"]').css('display', 'flex');
        }
    });


    $(document).on("click",".md_variouse_control__rh",function() {
        var currentIndex = parseFloat($(this).closest('.md_variouse_control').attr('data-index'));
        currentIndex++;
        
        $('.md_various_name_label').each(function(){
            if ($(this).attr('data-index') == currentIndex){
                $(this).trigger('click');
            }
        });
    });

    $(document).on("click",".md_variouse_control__lh",function() {
        var currentIndex = parseFloat($(this).closest('.md_variouse_control').attr('data-index'));
        if (currentIndex > 1){
            currentIndex--;
        }

        $('.md_various_name_label').each(function(){
            if ($(this).attr('data-index') == currentIndex){
                $(this).trigger('click');
            }
        });
    });

    $('.md_various_name_label').click(function(){
        $('.md_various_name_label').removeClass('active');
        $(this).addClass('active');
        var data_id = $(this).attr('data-id');
        $('.md_various_info_cell').hide();
        $('.md_various_info_cell').each(function(){
            if ($(this).attr('data-id') == data_id){
                $(this).show();
            }
        });
    });

    $('.md_sub_cell__select').click(function(){
        $('.md_sub_cell__select').removeClass('active');
        $(this).addClass('active');
        var data = $(this).attr('data');
        if (data == '1'){
            $('.md_inner').css('width', '35%');
        }
        else if (data == '2'){
            $('.md_inner').css('width', '68%');
        }
        else if ( data == '3'){
            $('.md_inner').css('width', '100%');
        }
    });

    $('.md_faq_block').click(function(){
        if ($(this).hasClass('active')){
            $('.md_faq_block').removeClass('active');
            $('.md_faq_block').find('.md_faq_block_content').slideUp();
        }
        else{
            $('.md_faq_block').removeClass('active');
            $('.md_faq_block').find('.md_faq_block_content').slideUp();
            $(this).find('.md_faq_block_content').slideDown();
            $(this).addClass('active');
        }
    });

    $('.md_faqs_expand_button_outer').click(function(){
        var data = $(this).attr('data');
        if (data == '1'){
            $(this).attr('data', '0');
            $('.md_hidden_quest').slideDown();
            $('.md_expand_btn_text').text('Less Questions');
            $('.md_expand_minus_btn').css('display', 'flex');
            $('.md_expand_plus_btn').hide();
        }
        else if (data == '0'){
            $(this).attr('data', '1');
            $('.md_hidden_quest').slideUp();
            $('.md_expand_btn_text').text('More Questions');
            $('.md_expand_minus_btn').hide();
            $('.md_expand_plus_btn').show();
        }
    });

    $('.md_whats_inside_btn_outer a').click(function(event){
        event.preventDefault();
        var currentMode = $(this).closest('.md_whats_inside_btn_outer').attr('data');
        if (currentMode == '0'){
            $('.md_whats_inside_hidden').show();
            $(this).closest('.md_whats_inside_btn_outer').attr('data', '1');
            $(this).text('SHOW LESS');
        }
        else{
            $('.md_whats_inside_hidden').hide();
            $(this).closest('.md_whats_inside_btn_outer').attr('data', '0');
            $(this).text('SHOW MORE');
            $('html, body').animate({
                scrollTop: $(".md_whats_inside_grid").offset().top-100
            }, 0);
        }
    });

    $('.md_references_tab').click(function(){
        $(this).closest('.md_read_popup_refe').find('.md_read_study_ref_content').slideToggle();
        $(this).closest('.md_read_popup_refe').toggleClass('noactive');
    });

    $('.md_popup_close').click(function(){
        $('.md_ready_study_popup_out').hide();
        $('body').removeClass('overflow_hidden');
        $('html').removeClass('overflow_hidden');
    });

    $('.md_read_study_popup_trigger').click(function(event){
        event.preventDefault();
        $('.md_read_study').css('display', 'flex');
        $('body').addClass('overflow_hidden');
        $('html').addClass('overflow_hidden');
    });

    $('.md_view_supple_popup_trigger').click(function(event){
        event.preventDefault();
        $('.md_view_supple').css('display', 'flex');
        $('body').addClass('overflow_hidden');
        $('html').addClass('overflow_hidden');
    });

    $(document).on("click",".md_ugcs_sound",function(event) {
        var video = $('.md_ugcs_popup_outer.active .md_ugcs_popup_video')[0];
        if (video.muted == true) {
            $('.md_ugcs_muted').hide();
            $('.md_ugcs_unmuted').show();
            video.muted = false;
        } else {
            video.muted = true;
            $('.md_ugcs_muted').show();
            $('.md_ugcs_unmuted').hide();
        }
    });

    $('.md_ugcs_close').click(function(){
        $('.md_ugcs_popup_outer').hide();
        $('.md_ugcs_close').hide();
        $('.md_ugcs_sound').hide();
        $('.md_ugcs_next').hide();
        $('.md_ugcs_prev').hide();
        $('.md_ugcs_popup_outer').find('video').each(function() {
            this.pause(); 
        });
        $('body').removeClass('overflow_hidden');
        $('html').removeClass('overflow_hidden');
    });

    $('.md_ugc_video_popup').click(function(){
        $('body').addClass('overflow_hidden');
        $('html').addClass('overflow_hidden');
        var current_index = $(this).attr('data-index');
        console.log(current_index, 'CURRENT INDEX');
        $('.md_ugcs_close').css('display', 'flex');
        $('.md_ugcs_sound').css('display', 'flex');
        $('.md_ugcs_next').css('display', 'flex');
        $('.md_ugcs_prev').css('display', 'flex');
        $('.md_ugcs_popup_outer').removeClass('active');
        $('.md_ugcs_popup_outer[data-index="'+current_index+'"]').addClass('active');
        $('.md_ugcs_popup_outer[data-index="'+current_index+'"]').css('display', 'flex');
        console.log(current_index, 'CURRENT INDEX');
        var video = $('.md_ugcs_popup_outer[data-index="'+current_index+'"]').find('.md_ugcs_popup_video')[0];
        video.play();
    });

    $(document).on("click",".md_ugcs_popup_video",function(event) {
        if (this.paused) {
            $('.md_ugcs_play_icon').hide();
            this.play();
        } else {
            this.pause();
            $(this).closest('.md_ugcs_popup_outer').find('.md_ugcs_play_icon').show();
        }   
    });
  
    $(document).on("click",".md_ugcs_play_icon",function(event) {
        var video = $(this).parent('.md_ugcs_popup_outer').find('video')[0];
        video.play();
        $('.md_ugcs_play_icon').hide();
    });
});